import { render, staticRenderFns } from "./addZJXX.vue?vue&type=template&id=63886fd9&scoped=true&"
import script from "./addZJXX.vue?vue&type=script&lang=js&"
export * from "./addZJXX.vue?vue&type=script&lang=js&"
import style0 from "./addZJXX.vue?vue&type=style&index=0&id=63886fd9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63886fd9",
  null
  
)

export default component.exports